import React from 'react';
import { Island } from '@trevor/ui-components';
import { Cohort } from '@/features/dataPresentation/navigation/buttons';
import {
  BAR,
  BARLINE,
  LINE,
  PIE,
  PIVOT,
} from '@/components/charting/chartType.constants';
import { useGetQueryBuilderSummarizeConfig } from '@/features/queryConfig/hooks/useGetQueryBuilderSummarizeConfig';
import { SINGLE_VALUE } from '@/components/ChartHolder.constants';
import { useDispatchUpdatesToMetricConfig } from '@/features/queryMetricsDimensionsConfig/hooks/useDispatchUpdatesToMetricConfig';
import {
  useHeadings_LEGACY,
  useLoadRows_LEGACY,
} from '@/features/query-builder/hooks/LEGACY';
import {
  Bar,
  BarLine,
  EditQuery,
  Line,
  Pie,
  Pivot,
  SingleValue,
  Stacked,
  Table,
} from './connected-buttons';

export const DataPresentationNavigation = () => {
  const { data, isReady } = useGetQueryBuilderSummarizeConfig();
  const { isSuccess } = useLoadRows_LEGACY();
  useDispatchUpdatesToMetricConfig();

  const headings = useHeadings_LEGACY();
  const hasData = isSuccess && !!headings && !!data && isReady;
  const isPivotPossible = hasData && PIVOT in data;
  const isSingleValuePossible = hasData && SINGLE_VALUE in data;
  const isPiePossible = hasData && PIE in data;
  const isBarPossible = hasData && BAR in data;
  const isLinePossible = hasData && LINE in data;
  const isBarLinePossible = hasData && BARLINE in data;
  const isStackedPossible = hasData && 'stacked' in data;

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        marginTop: '16px',
      }}
    >
      <Island size="big">
        <EditQuery />
        <Table />
        <Pivot available={isPivotPossible} />
        <SingleValue available={isSingleValuePossible} />
        <Pie available={isPiePossible} />
        <Bar available={isBarPossible} />
        <Line available={isLinePossible} />
        <BarLine available={isBarLinePossible} />
        <Stacked available={isStackedPossible} />
        <Cohort />
      </Island>
    </div>
  );
};
